"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusBar = exports.STATUSBAR_STYLE_TYPE = exports.STATUSBAR_STATUS = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Full = require("./Full");
var _Short = require("./Short");
require("./StatusBar.scss");
let STATUSBAR_STATUS = exports.STATUSBAR_STATUS = /*#__PURE__*/function (STATUSBAR_STATUS) {
  STATUSBAR_STATUS["done"] = "done";
  STATUSBAR_STATUS["inProgress"] = "inProgress";
  return STATUSBAR_STATUS;
}({});
let STATUSBAR_STYLE_TYPE = exports.STATUSBAR_STYLE_TYPE = /*#__PURE__*/function (STATUSBAR_STYLE_TYPE) {
  STATUSBAR_STYLE_TYPE["full"] = "full";
  STATUSBAR_STYLE_TYPE["short"] = "short";
  return STATUSBAR_STYLE_TYPE;
}({});
const StatusBar = _ref => {
  let {
    className,
    statuses,
    styleType = STATUSBAR_STYLE_TYPE.short
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-StatusBar', className);
  switch (styleType) {
    case STATUSBAR_STYLE_TYPE.short:
      return /*#__PURE__*/_react.default.createElement(_Short.Short, {
        className: rootClassName,
        statuses: statuses
      });
    case STATUSBAR_STYLE_TYPE.full:
    default:
      return /*#__PURE__*/_react.default.createElement(_Full.Full, {
        className: rootClassName,
        statuses: statuses
      });
  }
};
exports.StatusBar = StatusBar;
//# sourceMappingURL=StatusBar.js.map